module.exports = __webpack_public_path__ + "img/family.7d80f717.png";